
/**
 * Classe responsável em manter atributos para realização do Login nas aplicações PIMS.
 */
export class AgroLoginModel {
    password: string;
    user: string;
}